import {
  SETTINGS_LOADED,
  SETTINGS_UPDATED,
  LOGOUT,
} from "../actions/ActionTypes";

const initialState = {
  loading: true,
  error: {},
  setting: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SETTINGS_LOADED:
      return {
        ...state,
        setting: payload,
        loading: false,
      };
    case SETTINGS_UPDATED:
      return {
        ...state,
        setting: payload,
        loading: false,
      };
    case LOGOUT:
      return {
        ...state,
        setting: null,
        loading: false,
      };
    default:
      return state;
  }
}
